import jwt_decode from "jwt-decode";
import { localsync } from "localsync";

import StringHelper from "~/helpers/StringHelper";

const storageKey = "influxAdmin";

export default class Authentication {
  static token = null;
  static user = null;

  static loadFromStorage = () => {
    let json = null;
    const item = localStorage.getItem(storageKey);

    if (item) {
      try {
        json = JSON.parse(item);

        // check structure & clean if altered
        if (StringHelper.isNullOrEmpty(json.token) || !json.user) {
          localStorage.setItem(storageKey, null);
          return null;
        }

        Authentication.token = json.token;
        Authentication.user = json.user;
      } catch (e) {}
    }

    return json;
  };

  static isLogged = () => {
    if (
      !Authentication.user ||
      StringHelper.isNullOrEmpty(Authentication.token)
    ) {
      let json = Authentication.loadFromStorage();
      return json && !StringHelper.isNullOrEmpty(json.token);
    }

    return true;
  };

  static login = (token, sync = true) => {
    const tokenData = jwt_decode(token);
    const { sub, exp, iat, iss, jti, nbf, prv, ...userData } = tokenData;

    let data = {
      token: token,
      user: {
        id: +tokenData.sub,
        ...userData,
      },
    };

    Authentication.token = token;
    Authentication.user = data.user;

    if (sync) {
      localStorage.setItem(storageKey, JSON.stringify(data));
      authController.trigger(token);
    }
  };

  static logout = (sync = true) => {
    Authentication.token = null;
    Authentication.user = null;

    if (sync) {
      localStorage.setItem(storageKey, null);
      authController.trigger(null);
    }
  };
}

const createAuthSync = localsync({ channel: storageKey });
const publisher = (token) => ({ token });
const subscriber = (current) => {
  if (Authentication.token === (current?.token ?? null)) {
    return;
  }

  if (!current || !current.token) {
    Authentication.logout(false);
  } else if (Authentication.token !== current.token) {
    Authentication.login(current.token, false);
  }
};

const authController = createAuthSync(publisher, subscriber);
authController.start(true);
